<template>
  <div>
    <router-view/>
    <loading v-if="loading"/>
  </div>
</template>

<script>
import loading from '@/components/Utils/Loading.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  components: {
    loading
  },
  mounted () {
    document.title = this.info.name
    this.$vuetify.theme.themes.light.primary = this.info.theme_primary
    this.$vuetify.theme.themes.dark.primary = this.info.theme_primary

    this.$vuetify.theme.themes.light.accent = this.info.theme_accent
    this.$vuetify.theme.themes.dark.accent = this.info.theme_accent

    this.$vuetify.theme.themes.light.secondary = this.info.theme_secondary
    this.$vuetify.theme.themes.dark.secondary = this.info.theme_secondary

    this.$vuetify.theme.themes.light.menuColor = this.info.theme_menu_color
    this.$vuetify.theme.themes.dark.menuColor = this.info.theme_menu_color

    this.$vuetify.theme.themes.light.menuBackground = this.info.theme_menu_background
    this.$vuetify.theme.themes.dark.menuBackground = this.info.theme_menu_background

    this.$vuetify.theme.themes.light.backgroundVariant = this.info.theme_background_variant
    this.$vuetify.theme.themes.dark.backgroundVariant = this.info.theme_background_variant

    this.$vuetify.theme.themes.light.loginBackground = this.info.theme_login_background
    this.$vuetify.theme.themes.dark.loginBackground = this.info.theme_login_background

    this.$vuetify.theme.themes.light.loginFont = this.info.theme_login_font
    this.$vuetify.theme.themes.dark.loginFont = this.info.theme_login_font

    this.$vuetify.theme.themes.light.loginButton = this.info.theme_login_button
    this.$vuetify.theme.themes.dark.loginButton = this.info.theme_login_button
  },
  computed: {
    ...mapGetters({
      loading: 'App/loading',
      info: ['App/info']
    })
  }
}
</script>
<style>
.tox-notifications-container {
  display: none !important;
}
</style>
